import { useEffect } from 'react';
import { useEventBus } from '../runtime';
export function useEventBusListener(eventName, callback, { once } = {}) {
    const eventBus = useEventBus();
    return useEffect(() => {
        eventBus.addListener(eventName, callback, { once });
        return () => {
            eventBus.removeListener(eventName, callback, { once });
        };
    }, [eventName, callback, once]);
}
